const VideosData = [
  {
    id: 1,
    image:
      "https://i.ibb.co/XbW1XBz/china.jpg",
    text: "US warships transit Taiwan Strait, first since Pelosi visit",
    description:
      "Two US Navy warships sailed through international waters in the Taiwan Strait on Sunday, the first such operation since a visit to Taiwan by US House Speaker Nancy",
    link: "https://www.youtube.com/watch?v=qaYQNyJlNFk&t=6s",
    path: "US warships transit Taiwan Strait, first since Pelosi visit",
  },
  
  {
    id: 2,
    image:
      "https://i.ibb.co/JCrBHG4/pakistan.jpg",
    text: "Satellite Images Show Damage From Deadly Flooding in Pakistan",
    description:
      "Floodwaters have swept buildings off their foundations, washed away bridges and roads and inundated the country’s farmland.",
    link: "https://www.youtube.com/watch?v=eNUchTJcw9o",
    path: "Satellite Images Show Damage From Deadly Flooding in Pakistan",
  },
  {
    id: 3,
    image:
      "  https://i.ibb.co/nfMh7Xn/nasa.jpg",
    text: "NASA Postpones Artemis Moon Rocket Launch After Engine Issue",
    description:
      "The launch was canceled after a liquid hydrogen line did not adequately cool one of the rocket’s engines.",
    link: "https://www.youtube.com/watch?v=KxL1wpY4F84",
    path: "NASA Postpones Artemis Moon Rocket Launch After Engine Issue",
  },
  {
    id: 4,
    image:
      "  https://i.ibb.co/y0GZJk4/iraq.jpg",
    text: "Followers of Powerful Iraqi Cleric Breach Green Zone in Baghdad",
    description:
      "Muqtada al-Sadr’s announcement that he would leave politics sent hundreds of his followers into the streets of Baghdad, where they breached concrete barriers guarding the so-called Green Zone.",
    link: "https://www.youtube.com/watch?v=_MY4fJvfCXY",
    path: "Followers of Powerful Iraqi Cleric Breach Green Zone in Baghdad",
  },
  {
    id: 5,
    image:
      "  https://i.ibb.co/M6t6c9F/corona.jpg",
    text: "Low Pay, High Risk: Nursing Home Workers Confront Coronavirus Dilemma",
    description:
      "“Who else is going to take care of them?” We spoke with nursing home workers about their fear of catching and spreading coronavirus.",
    link: "https://www.youtube.com/watch?v=f1GA5hlVR2I",
    path: "Low Pay, High Risk: Nursing Home Workers Confront Coronavirus Dilemma",
  },




  {
    id: 6,
    image:
      "https://i.ibb.co/zR0wVFc/pulizerjpeg.jpg",
    text: "Pulitzer Winner Bangladeshi",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam, suscipit nulla repellat facere ratione consequuntur maiores necessitatibus eius quam praesentium expedita iure distinctio dicta laboriosam labore, velit corrupti? Quo, alias.",
    link: "https://www.youtube.com/watch?v=wE7ngVMLADg",
    path: "Pulitzer Winner Bangladeshi",
  },
  {
    id: 7,
    image:
      "https://i.ibb.co/Ct1ZxxZ/scool.jpg",
    text: "Office and School Hour Conflict",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam, suscipit nulla repellat facere ratione consequuntur maiores necessitatibus eius quam praesentium expedita iure distinctio dicta laboriosam labore, velit corrupti? Quo, alias.",
    link: "https://www.youtube.com/watch?v=IoR7AIgD2So",
    path: "Office and School Hour Conflict",
  },
  {
    id: 8,
    image:
      "https://images.prothomalo.com/prothomalo-english%2F2022-06%2F460340dc-3b93-4260-b23c-32c6ecdb7309%2FAtomic_Energy.webp?rect=0%2C27%2C640%2C427&auto=format%2Ccompress&fmt=webp&format=webp&w=320&dpr=1.0",
    text: "Road accident in Savar's Baliarpur",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam, suscipit nulla repellat facere ratione consequuntur maiores necessitatibus eius quam praesentium expedita iure distinctio dicta laboriosam labore, velit corrupti? Quo, alias.",
    link: "https://www.youtube.com/watch?v=eWwJystPngI&t=3s",
    path: "Road accident in Savar's Baliarpur",
  },
  {
    id: 9,
    image:
      "https://images.prothomalo.com/prothomalo-english%2F2021-09%2Fedc30782-8305-4d55-bf7d-4866c96e0e64%2FHealth_photo.png?rect=47%2C0%2C507%2C338&auto=format%2Ccompress&fmt=webp&format=webp&w=128&dpr=1.0",
    text: "Covid-19 and necessity of quality health services",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam, suscipit nulla repellat facere ratione consequuntur maiores necessitatibus eius quam praesentium expedita iure distinctio dicta laboriosam labore, velit corrupti? Quo, alias.",

    link: "https://www.youtube.com/watch?v=psT8IUQKVNk",
    path: "Covid-19 and necessity of quality health services",
  },
  {
    id: 10,
    image:
      "https://images.prothomalo.com/prothomalo-english%2F2022-07%2Ff35cd683-c23b-44c1-8685-318356f0f5f0%2Fprothomalo_bangla_2022_06_9d710664_9518_4177_bf98_51e6bbe98549_WhatsApp_Image_2022_07_01_at_3_08_14_.webp?rect=0%2C0%2C600%2C400&auto=format%2Ccompress&fmt=webp&format=webp&w=700&dpr=1.0",
    text: "Cricketers' sea voyage turns into nightmare",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam, suscipit nulla repellat facere ratione consequuntur maiores necessitatibus eius quam praesentium expedita iure distinctio dicta laboriosam labore, velit corrupti? Quo, alias.",
    link: "https://www.youtube.com/watch?v=oADRoRhLgNI",
    path: "Cricketers' sea voyage turns into nightmare",
  },
  {
    id: 11,
    image:
      "https://i.ibb.co/hfGBPz3/misicipi.jpg",
    text: "Mississippi Residents Brace for Flooding",
    description:
      "Two US Navy warships sailed through international waters in the Taiwan Strait on Sunday, the first such operation since a visit to Taiwan by US House Speaker Nancy",
    link: "https://www.youtube.com/watch?v=qaYQNyJlNFk&t=6s",
    path: "Mississippi Residents Brace for Flooding",
  },
  
  {
    id: 12,
    image:
      "https://i.ibb.co/92GpwVy/russaia.jpg",
    text: "Tracking Russia’s Latest Military Movements Around Ukraine",
    description:
      "Floodwaters have swept buildings off their foundations, washed away bridges and roads and inundated the country’s farmland.",
    link: "https://www.youtube.com/watch?v=eNUchTJcw9o",
    path: "Tracking Russia’s Latest Military Movements Around Ukraine",
  },
  {
    id: 13,
    image:
      "  https://i.ibb.co/RHs7WB3/corona72.jpg",
    text: "‘People Are Dying’: 72 Hours Inside a N.Y.C. Hospital Battling Coronavirus",
    description:
      "The launch was canceled after a liquid hydrogen line did not adequately cool one of the rocket’s engines.",
    link: "https://www.youtube.com/watch?v=KxL1wpY4F84",
    path: "‘People Are Dying’: 72 Hours Inside a N.Y.C. Hospital Battling Coronavirus",
  },
  
  
  {
    id: 14,
    image:
      "  https://i.ibb.co/y0GZJk4/iraq.jpg",
    text: "Followers of Powerful Iraqi Cleric Breach Green Zone in Baghdad",
    description:
      "Muqtada al-Sadr’s announcement that he would leave politics sent hundreds of his followers into the streets of Baghdad, where they breached concrete barriers guarding the so-called Green Zone.",
    link: "https://www.youtube.com/watch?v=_MY4fJvfCXY",
    path: "Followers of Powerful Iraqi Cleric Breach Green Zone in Baghdad",
  },
  {
    id: 15,
    image:
      "  https://i.ibb.co/M6t6c9F/corona.jpg",
    text: "Low Pay, High Risk: Nursing Home Workers Confront Coronavirus Dilemma",
    description:
      "“Who else is going to take care of them?” We spoke with nursing home workers about their fear of catching and spreading coronavirus.",
    link: "https://www.youtube.com/watch?v=f1GA5hlVR2I",
    path: "Low Pay, High Risk: Nursing Home Workers Confront Coronavirus Dilemma",
  },




  {
    id: 16,
    image:
      "https://i.ibb.co/zR0wVFc/pulizerjpeg.jpg",
    text: "Pulitzer Winner Bangladeshi",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam, suscipit nulla repellat facere ratione consequuntur maiores necessitatibus eius quam praesentium expedita iure distinctio dicta laboriosam labore, velit corrupti? Quo, alias.",
    link: "https://www.youtube.com/watch?v=wE7ngVMLADg",
    path: "Pulitzer Winner Bangladeshi",
  },
  {
    id: 17,
    image:
      "https://i.ibb.co/Ct1ZxxZ/scool.jpg",
    text: "Office and School Hour Conflict",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam, suscipit nulla repellat facere ratione consequuntur maiores necessitatibus eius quam praesentium expedita iure distinctio dicta laboriosam labore, velit corrupti? Quo, alias.",
    link: "https://www.youtube.com/watch?v=IoR7AIgD2So",
    path: "Office and School Hour Conflict",
  },
  {
    id: 18,
    image:
      "https://images.prothomalo.com/prothomalo-english%2F2022-06%2F460340dc-3b93-4260-b23c-32c6ecdb7309%2FAtomic_Energy.webp?rect=0%2C27%2C640%2C427&auto=format%2Ccompress&fmt=webp&format=webp&w=320&dpr=1.0",
    text: "Road accident in Savar's Baliarpur",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam, suscipit nulla repellat facere ratione consequuntur maiores necessitatibus eius quam praesentium expedita iure distinctio dicta laboriosam labore, velit corrupti? Quo, alias.",
    link: "https://www.youtube.com/watch?v=eWwJystPngI&t=3s",
    path: "Road accident in Savar's Baliarpur",
  },
  {
    id: 19,
    image:
      "https://images.prothomalo.com/prothomalo-english%2F2021-09%2Fedc30782-8305-4d55-bf7d-4866c96e0e64%2FHealth_photo.png?rect=47%2C0%2C507%2C338&auto=format%2Ccompress&fmt=webp&format=webp&w=128&dpr=1.0",
    text: "Covid-19 and necessity of quality health services",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam, suscipit nulla repellat facere ratione consequuntur maiores necessitatibus eius quam praesentium expedita iure distinctio dicta laboriosam labore, velit corrupti? Quo, alias.",

    link: "https://www.youtube.com/watch?v=psT8IUQKVNk",
    path: "Covid-19 and necessity of quality health services",
  },
  {
    id: 20,
    image:
      "https://images.prothomalo.com/prothomalo-english%2F2022-07%2Ff35cd683-c23b-44c1-8685-318356f0f5f0%2Fprothomalo_bangla_2022_06_9d710664_9518_4177_bf98_51e6bbe98549_WhatsApp_Image_2022_07_01_at_3_08_14_.webp?rect=0%2C0%2C600%2C400&auto=format%2Ccompress&fmt=webp&format=webp&w=700&dpr=1.0",
    text: "Cricketers' sea voyage turns into nightmare",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam, suscipit nulla repellat facere ratione consequuntur maiores necessitatibus eius quam praesentium expedita iure distinctio dicta laboriosam labore, velit corrupti? Quo, alias.",
    link: "https://www.youtube.com/watch?v=oADRoRhLgNI",
    path: "Cricketers' sea voyage turns into nightmare",
  },
];



export default VideosData;
